// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { APPRelationship } from './APPRelationship';
import { APPComponent } from './APPComponent';
import { Task } from './Task';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { TaskSequenceExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/APPModel/TaskSequenceExtend';
/**
 * 任务顺序关系 实体类
 * 任务顺序关系
 */
export class TaskSequence extends APPRelationship {
  /** 应用组件 的ID */
  private _aPPComponent_ID: string;

  /** 获取：应用组件 的ID */
  public get aPPComponent_ID() {
    return this._aPPComponent_ID;
  }

  /** 设置：应用组件 的ID */
  public set aPPComponent_ID(value: string) {
    this._aPPComponent_ID = value;
  }

  /** 应用组件  */
  private _aPPComponent: APPComponent;

  /** 获取：应用组件  */
  public get aPPComponent() {
    return this._aPPComponent;
  }

  /** 设置：应用组件  */
  public set aPPComponent(value: APPComponent) {
    this._aPPComponent = value;
    if (value !== null) {
      this.aPPComponent_ID = value.id;
    } else {
      this.aPPComponent_ID = '';
    }
  }

  /** 前置任务 的ID */
  private _beforeTask_ID: string;

  /** 获取：前置任务 的ID */
  public get beforeTask_ID() {
    return this._beforeTask_ID;
  }

  /** 设置：前置任务 的ID */
  public set beforeTask_ID(value: string) {
    this._beforeTask_ID = value;
  }

  /** 前置任务  */
  private _beforeTask: Task;

  /** 获取：前置任务  */
  public get beforeTask() {
    return this._beforeTask;
  }

  /** 设置：前置任务  */
  public set beforeTask(value: Task) {
    this._beforeTask = value;
    if (value !== null) {
      this.beforeTask_ID = value.id;
    } else {
      this.beforeTask_ID = '';
    }
  }

  /** 后置任务 的ID */
  private _afterTask_ID: string;

  /** 获取：后置任务 的ID */
  public get afterTask_ID() {
    return this._afterTask_ID;
  }

  /** 设置：后置任务 的ID */
  public set afterTask_ID(value: string) {
    this._afterTask_ID = value;
  }

  /** 后置任务  */
  private _afterTask: Task;

  /** 获取：后置任务  */
  public get afterTask() {
    return this._afterTask;
  }

  /** 设置：后置任务  */
  public set afterTask(value: Task) {
    this._afterTask = value;
    if (value !== null) {
      this.afterTask_ID = value.id;
    } else {
      this.afterTask_ID = '';
    }
  }

  constructor() {
    super();
    TaskSequenceExtend.Init(this);
    this._aPPComponent_ID = '';
    this._aPPComponent = null;
    this._beforeTask_ID = '';
    this._beforeTask = null;
    this._afterTask_ID = '';
    this._afterTask = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: TaskSequence, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.aPPComponent_ID = element.aPPComponent_ID;
      if (hasReference && element.aPPComponent !== null) {
        this.aPPComponent = element.aPPComponent;
      }
      this.beforeTask_ID = element.beforeTask_ID;
      if (hasReference && element.beforeTask !== null) {
        this.beforeTask = element.beforeTask;
      }
      this.afterTask_ID = element.afterTask_ID;
      if (hasReference && element.afterTask !== null) {
        this.afterTask = element.afterTask;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.aPPComponent_ID = json.APPComponent_ID;
    // if (json.APPComponent !== null) {
    //   this.aPPComponent = APPComponent.Create(json.APPComponent);
    // }
    this.beforeTask_ID = json.BeforeTask_ID;
    // if (json.BeforeTask !== null) {
    //   this.beforeTask = Task.Create(json.BeforeTask);
    // }
    this.afterTask_ID = json.AfterTask_ID;
    // if (json.AfterTask !== null) {
    //   this.afterTask = Task.Create(json.AfterTask);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.APPComponent_ID = this.aPPComponent_ID;
    json.BeforeTask_ID = this.beforeTask_ID;
    json.AfterTask_ID = this.afterTask_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): TaskSequence {
    const taskSequence = new TaskSequence();
    taskSequence.Deserialize(json);
    taskSequence.json = json;
    return taskSequence;
  }
}
